import { environment } from 'src/environments/environment';
import { EnvironmentApplication } from 'src/environments/models/environment-application';

export enum GalleryViewMode {
  List,
  Card,
}

export const GalleryViewModeDefault =
  environment.application === EnvironmentApplication.Loft
    ? GalleryViewMode.List
    : GalleryViewMode.Card;
